export const Constants = {
    GM_DGA_ID: 705,
    DNC_FLEXIBLE: 23,
    CONTROL_PANEL_URL: 'https://cp.neogig.com.br'
};



// WEBPACK FOOTER //
// ./src/constants/constants.js